module.exports = __webpack_public_path__ + "img/섀도우댄서.0050cc2f.png";